import { Component, Prop, Watch } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import FieldWrapper from '../field-wrapper/field-wrapper.vue';
import AbstractField from '@/app/modules/shared/components/forms/inputs/abstract-field/abstract-field';
import { MediaCollection } from '@shared/interfaces/inputs';
import { BFormFile } from 'bootstrap-vue';

@Component({
  name: 'bpc-file',
  components: {
    'bpc-field-wrapper': FieldWrapper,
    'b-form-file': BFormFile,
  },
})
export default class File extends mixins(AbstractField) {
  @Prop() readonly value: AnyEntity;
  @Prop([Object, Array]) readonly mediaCollection: MediaCollection;

  get model(): object | string[] {
    return this.modelFile;
  }
  set model(val: object | string[]) {
    this.modelFile = val;
    this.$emit('input', val);
    if (this.eventsConfig && this.eventsConfig.emit) {
      this.eventsConfig.emit.forEach(event => {
        this.$root.$emit(event, val);
      });
    }
  }

  modelFile = null;
  showPreview: boolean = false;
  showDeleteBtn: boolean = false;
  url: string = null;
  acceptsMimeTypes: string = 'image/jpg,image/jpeg,image/png';

  get accepts() {
    return this.mediaCollection?.acceptsMimeTypes?.join(',') || this.acceptsMimeTypes;
  }

  get multiple() {
    return Object.keys(this.mediaCollection).length !== 0
      ? !this.mediaCollection.singleFile
      : false;
  }

  get showDeleteButton() {
    if (this.value == null) {
      return (this.showDeleteBtn = false);
    } else if (this.$attrs?.hideDeleteButton) {
      return (this.showDeleteBtn = false);
    } else {
      return this.showDeleteBtn;
    }
  }

  get hidePreview() {
    if (this.value == null) {
      return (this.showPreview = false);
    }
  }

  get deleted(): boolean {
    if (this.getId() != null) {
      return this.$store.getters['media/statusMedia'](this.getId());
    } else {
      return false;
    }
  }

  onFileChange(event) {
    // works with drag and drop but not with change input.
    // const file = event.dataTransfer.files[0];

    // works with change input but not with drag and drop.
    const file = event.target.files[0];
    this.setPreviewImage(file);
  }

  setPreviewImage(file) {
    const type = file?.type;
    this.showPreview = type ? type.startsWith('image') : false;
    this.showDeleteBtn = true;
    this.url = URL.createObjectURL(file);
  }

  deleteMediaFile() {
    const id = this.getId();
    if (id == null) {
      this.modelFile = null;
      this.showPreview = false;
      this.showDeleteBtn = false;
    } else {
      const media = this.value;
      media['deleted'] = false;
      this.$store.commit('media/storeMedia', { id: id.toString(), media: media });
      this.$emit('delete-media-file', id);
    }
    this.url = null;
  }

  getId() {
    let id;

    if (this.value == null) {
      id = null;
    } else if (Array.isArray(this.value)) {
      id = this.value[0]['id'];
    } else if (typeof this.value === 'object') {
      id = this.value['id'];
    } else {
      id = null;
    }

    return id;
  }

  setImageFromModel() {
    if (this.value && this.value['id']) {
      if (typeof this.value === 'string') {
        this.showPreview = true;
        this.showDeleteBtn = true;
        this.url = this.value;
      } else if (Array.isArray(this.value) && this.value[0]['url']) {
        const mimeType = this.value[0]['mimeType'];
        this.showPreview = mimeType ? mimeType.startsWith('image') : false;
        this.showDeleteBtn = true;
        this.url = this.value[0]['url'];
      } else if (typeof this.value === 'object' && this.value['url']) {
        const mimeType = this.value['mimeType'];
        this.showPreview = mimeType ? mimeType.startsWith('image') : false;
        this.showDeleteBtn = true;
        this.url = this.value['url'];
      }
    }
  }

  mounted() {
    this.$root.$on('changeMimeTypes', val => {
      switch (val) {
        case 'documents':
          this.acceptsMimeTypes =
            'application/msword,application/vnd.oasis.opendocument.text,application/pdf,application/vnd.ms-excel,application/vnd.oasis.opendocument.spreadsheet,text/plain';
          break;
        case 'images':
          this.acceptsMimeTypes = 'image/jpg,image/jpeg,image/png';
          break;
        default:
          this.acceptsMimeTypes = 'image/jpg,image/jpeg,image/png';
      }
    });
    this.setImageFromModel();
  }

  @Watch('value')
  onValueChange() {
    if (this.value === null) {
      this.showDeleteBtn = false;
      this.showPreview = false;
    }
  }

  @Watch('deleted')
  onDeleteChange() {
    if (this.deleted) {
      this.showPreview = false;
      this.showDeleteBtn = false;
      this.url = null;
    }
  }
  // updated () { }

  destroyed() {
    this.$root.$off('changeMimeTypes');
  }
}
